import { memo } from 'react';

import ErrorDuotoneIconSVG from '@/assets/alert-triangle-duotone-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IErrorDuotoneIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ErrorDuotoneIconSVG} {...props} />
);

export const ErrorDuotoneIcon = memo(IErrorDuotoneIcon) as typeof IErrorDuotoneIcon;
